import {useContext, useEffect} from 'react';
import {Outlet, useLocation, useNavigate, useParams} from 'react-router-dom';
import AppContext from '@context/AppContext';

const SUPPORTED_LANGS = ['sk', 'en'];

/**
 * LanguageLayout - validates the /:lang URL param, syncs it into AppContext, renders child routes.
 * Redirects any unsupported lang value to the /sk equivalent.
 * This is the single source of truth for what constitutes a valid language.
 * @returns {JSX.Element | null}
 */
export default function LanguageLayout() {
    const {lang} = useParams<{lang: string}>();
    const location = useLocation();
    const navigate = useNavigate();
    const {setLang} = useContext(AppContext);

    useEffect(() => {
        if (!SUPPORTED_LANGS.includes(lang)) {
            const corrected = location.pathname.replace(`/${lang}`, '/sk');
            navigate(corrected + location.search, {replace: true});
            return;
        }
        setLang(lang);
    }, [lang, location.pathname, location.search, navigate, setLang]);

    if (!SUPPORTED_LANGS.includes(lang)) return null;

    return <Outlet />;
}
